import { styled } from '@mui/material/styles';

import palette from '../../../../theme/learnerPalette';
import AtomGrid from '../../../atoms/AtomGrid';
import { styleConfigs } from '../../../resources/styleConfigs';

export const LogoContainerStyled = styled(AtomGrid)({
  display: 'flex',
  justifyContent: 'center',
  width: styleConfigs.dimensions.width145,
  borderRadius: styleConfigs.borders.radius10,
  cursor: 'pointer',
  '&:focus-visible': {
    border: `${styleConfigs.borders.borderLine2px} ${palette.light.borders.yaleBlue}`,
  },
});
